import React from 'react';
import TabTicketByParams from '../Tabs/TabTicketByParams';
import TicketFilterV2 from './Filter';
import styled from 'styled-components';

const RefundTickets = () => {
  return (
    <Container>
      <TicketFilterV2 type='REFUND' />
      <div className="tickets">
      <TabTicketByParams v2 tableKey={'REFUND'} />
      </div>
    </Container>
  );
};

export default RefundTickets;

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  .tickets {
    flex: 1;
    position: relative;
  }
`;
